import { CourseService } from './services/courses.service';
import { CoursesStoreFacade } from './facades/courses-store.facade';
import Vue from 'vue';

export class CoursesModule extends Vue {

  Store = new CoursesStoreFacade();
  Services = CourseService;

}